import React, { useContext } from "react";
import Flex from '@react-css/flex';
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import { StyledPartialInformacoesTs } from '../../styled-components/StyledPartialInformacoesTs.style';

export const PartialProjetoInterno = ({isFromProjetoInterno}) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);
    return (        
        <StyledPartialInformacoesTs>
                <div className="card pl-0 pr-0" style={{padding: timesheet?.timesheet.totalValorProBono != 'R$ 0,00' ? '2rem' : '1rem'}}>
                    <Flex className="timesheet-more-infs">
                        <Flex.Item className="col-sm-8">
                            <h5 className="title-row-info mb-0 mt-3">
                                Título &nbsp;
                                <span className="title-row-sub">
                                    {timesheet.projetoInterno.projetoInternoTitulo}
                                </span>
                            </h5>
                            <br></br>
                            <span className="legend-info">Descrição</span>
                            <p className="data-info pl-0 m-0">{timesheet.projetoInterno.projetoInternoDescricao}</p>
                        </Flex.Item>
                    </Flex>
                </div >
        </StyledPartialInformacoesTs>
    );
};
